// extracted by mini-css-extract-plugin
export var actionButton = "_k3-0";
export var fileInput = "_k3-2";
export var paperclip = "_k3-1";